import { format } from 'date-fns';
import { AXIS_LABEL_DATE_FORMAT_LONG } from 'shared/components/TimeseriesChart/constants';
import { TimeseriesChartItem } from 'shared/components/TimeseriesChart/types';

interface MarketDataTable {
  date: string;
}

export const getMarketDataTableData = (
  chartData: TimeseriesChartItem[]
): MarketDataTable[] => {
  const dataArray: MarketDataTable[] = [];

  chartData.forEach(({ data, name }) => {
    data.forEach((itemData, index) => {
      if (dataArray.length < data.length) {
        dataArray.push({
          date: format(itemData[0], AXIS_LABEL_DATE_FORMAT_LONG),
          [name]: itemData[1],
        });
      } else {
        dataArray[index] = {
          [name]: itemData[1],
          ...dataArray[index],
        };
      }
    });
  });

  return dataArray;
};
